<template>
  <div class="component-modal modal-large" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{$t("modal.spot_programming.spot.simpleSchedule.title")}}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>

      <div class="component-modal__row--half">
        <div class="component-modal__column--half component-modal__row__multiselect">
          <!-- <div class="component-modal-input component-modal-input--rename"> -->
            <label for="spotType">{{$t("modal.spot_programming.spot.simpleSchedule.spotType")}}</label>
            <Multiselect
              v-model="model.spotType"
              :placeholder="$t('modal.spot_programming.spot.detailedSchedule.spotType')"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              :options="[
                { value: 0, label: `${$t('modal.spot_programming.spot.options.spotType.audio')}` },
                { value: 1, label: `${$t('modal.spot_programming.spot.options.spotType.nonTraditionalSpot')}` },
                { value: 2, label: `${$t('modal.spot_programming.spot.options.spotType.sponsorship')}` },
              ]"
              @select="changeSpotType(model.spotType)" />

            <!-- <select name="spotType" id="spotType" v-model="model.spotType" @change="changeSpotType(model.spotType)">
              <option :value="0">{{$t("modal.spot_programming.spot.options.spotType.audio")}}</option>
              <option :value="1">{{$t("modal.spot_programming.spot.options.spotType.nonTraditionalSpot")}}</option>
              <option :value="2">{{$t("modal.spot_programming.spot.options.spotType.sponsor")}}</option>
            </select> -->
          <!-- </div> -->
        </div>
        <div class="component-modal__column--half component-modal__row__multiselect" v-if="model.spotType != 2">
          <label for="position">{{$t("modal.spot_programming.spot.simpleSchedule.spotPosition")}}</label>
          <Multiselect
              v-model="model.commercialBreakSpotPosition"
              :placeholder="$t('modal.placeholder_select')+$t('modal.spot_programming.spot.simpleSchedule.spotPosition')"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              :options="[
                { value: 0, label: `${$t('modal.spot_programming.spot.options.spotPosition.first')}` },
                { value: 1, label: `${$t('modal.spot_programming.spot.options.spotPosition.second')}` },
                { value: 10, label: `${$t('modal.spot_programming.spot.options.spotPosition.third')}` },
                { value: 11, label: `${$t('modal.spot_programming.spot.options.spotPosition.fourth')}` },
                { value: 12, label: `${$t('modal.spot_programming.spot.options.spotPosition.fifty')}` },
                { value: 2, label: `${$t('modal.spot_programming.spot.options.spotPosition.indistict')}` },
                { value: 22, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.fourth')}` },
                { value: 21, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.third')}` },
                { value: 20, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.second')}` },
                { value: 3, label: `${$t('modal.spot_programming.spot.options.spotPosition.penultimate')} ${$t('modal.spot_programming.spot.options.spotPosition.first')}` },
                { value: 4, label: `${$t('modal.spot_programming.spot.options.spotPosition.last')}` }
              ]"
              :style="{'color': !model.commercialBreakSpotPosition ? '#757575' : '#ffffffde'}" />

          <!-- <select name="position" id="position" v-model="model.commercialBreakSpotPosition" :style="{'color': !model.commercialBreakSpotPosition ? '#757575' : '#ffffffde'}">
            <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.simpleSchedule.spotPosition")}}</option>
            <option :value="0">{{$t("modal.spot_programming.spot.options.spotPosition.first")}}</option>
            <option :value="1">{{$t("modal.spot_programming.spot.options.spotPosition.second")}}</option>
            <option :value="10">{{$t("modal.spot_programming.spot.options.spotPosition.third")}}</option>
            <option :value="11">{{$t("modal.spot_programming.spot.options.spotPosition.fourth")}}</option>
            <option :value="12">{{$t("modal.spot_programming.spot.options.spotPosition.fifty")}}</option>
            <option :value="2">{{$t("modal.spot_programming.spot.options.spotPosition.indistict")}}</option>
            <option :value="22">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.fourth")}}</option>
            <option :value="21">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.third")}}</option>
            <option :value="20">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.second")}}</option>
            <option :value="3">{{$t("modal.spot_programming.spot.options.spotPosition.penultimate")}} {{$t("modal.spot_programming.spot.options.spotPosition.first")}}</option>
            <option :value="4">{{$t("modal.spot_programming.spot.options.spotPosition.last")}}</option>
          </select> -->
        </div>
        <div class="component-modal__column--half" v-else>
          <div class="component-modal-input component-modal-input--rename">
            <input type="number" name="position" id="position" v-model="model.commercialBreakSpotPosition" :placeholder="$t('modal.spot_programming.spot.simpleSchedule.spotPostion')">
            <label for="position">{{$t("modal.spot_programming.spot.simpleSchedule.spotPosition")}}</label>
          </div>
        </div>
      </div>
  
      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="spotFileName" id="spotFileName" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t(`modal.spot_programming.spot.simpleSchedule.${model.spotType == 1 ? 'titleMention' : 'spotFileName'}`)" v-model="model.filename" :class="{'invalid': submitted && v$.model.filename.$invalid}">
          <label for="spotFileName">{{$t(`modal.spot_programming.spot.simpleSchedule.${model.spotType == 1 ? 'titleMention' : 'spotFileName'}`)}}
            <small v-if="submitted && v$.model.filename.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row--third">
        <div class="component-modal__column--third">
          <div class="component-modal-input component-modal-input--rename">
            <input type="number" name="length" id="length" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.length" :class="{'invalid': submitted && v$.model.length.$invalid}">
            <label for="length">
              {{$t("modal.spot_programming.spot.simpleSchedule.length")}}
              <small v-if="submitted && v$.model.length.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
              <small class="time" v-if="model.length > 0">{{calculateTime(model.length)}}</small>
            </label> 
          </div>
        </div>

        <div class="component-modal__column--third component-modal__row__multiselect">
          <!-- <div class="component-modal-input component-modal-input--rename"> -->
            <label for="product">{{$t("modal.spot_programming.spot.simpleSchedule.product")}}
              <small v-if="submitted && v$.model.productId.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>

            <Multiselect
              v-model="model.productId"
              :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.simpleSchedule.product')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :canDeselect="false"
              :canClear="false"
              :options="listProducts"
              @select="updateProduct"
              :class="{'invalid': submitted && v$.model.productId.$invalid}" />

            <!-- <select name="product" id="product" v-model="model.productId" @change="updateProduct"  :class="{'invalid': submitted && v$.model.productId.$invalid}">
              <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.simpleSchedule.product")}}</option>
              <option v-for="product in listProducts" :key="product.id" :value="product.id">{{product.name}} | ${{product.price}}</option>
            </select> -->
          <!-- </div> -->
        </div> 
        
        <div class="component-modal__column--third">
          <div class="component-modal-input component-modal-input--rename">
            <input type="text" name="price" id="price" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.price">
            <label for="price">{{$t("modal.spot_programming.spot.simpleSchedule.price")}}
              <small v-if="comparePriceProduct(model.productId, model.price)" class="pill-required" style="background: #ffc107; margin-left: 4px" :title="$t('modal.spot_programming.spot.simpleSchedule.price_title')">{{$t("modal.spot_programming.spot.simpleSchedule.price_info")}}</small> 
            </label>
          </div>
        </div>
      </div>


      <div class="component-modal__row--half">
        <div class="component-modal__column--half">
          <div class="component-modal-input component-modal-input--rename">
            <input type="date" name="startDate" id="startDate" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.startDate" :class="{'invalid': submitted && v$.model.startDate.$invalid}">
            <label for="startDate">{{$t("modal.spot_programming.spot.simpleSchedule.startDate")}}
              <small v-if="submitted && v$.model.startDate.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
            </label>
          </div>
        </div>

        <div class="component-modal__column--half">
          <div class="component-modal-input component-modal-input--rename">
            <input type="date" name="endDate" id="endDate" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.endDate">
            <label for="endDate">{{$t("modal.spot_programming.spot.simpleSchedule.endDate")}}</label>
          </div>
        </div>
      </div>

      <div class="component-modal__row--half">
        <div class="component-modal__column--half component-modal__row__multiselect">
          <!-- <div class="component-modal-input component-modal-input--rename"> -->
            <label for="speaker">{{$t("modal.spot_programming.spot.simpleSchedule.speaker")}}</label>
            <Multiselect
              v-model="model.speakerId"
              :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.simpleSchedule.speaker')"
              track-by="customLabel"
              valueProp="id"
              label="customLabel"
              :searchable="false"
              :options="listspeakers" />

            <!-- <select name="speaker" id="speaker" v-model="model.speakerId">
              <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.simpleSchedule.speaker")}}</option>
              <option v-for="speakers in listspeakers" :key="speakers.id" :value="speakers.id">{{speakers.code}} - {{speakers.name}}</option>
            </select> -->
          <!-- </div> -->
        </div>
        <div class="component-modal__column--half">
          <div class="component-modal-input component-modal-input--rename">
            <input type="text" name="timeFee" id="timeFee" autocomplete="off" :placeholder="$t('modal.placeholder_insert')" v-model="model.timeFee">
            <label for="timeFee">{{$t("modal.spot_programming.spot.simpleSchedule.timeFee")}}</label>
          </div>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <textarea :disabled="model.spotType == 0 || model.spotType == 2" v-model="model.ntcText" name="NTCText" id="NTCText" cols="30" rows="3" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.spot.simpleSchedule.NTCText')" :class="{'invalid': submitted && model.spotType == 1 && model.ntcText == '', 'unformatted': true}" @change="calculateTimeMention"></textarea>
          <label for="NTCText">{{$t("modal.spot_programming.spot.simpleSchedule.text")}}
              <small v-if="submitted && model.spotType == 1 && model.ntcText == ''" class="pill-required">* {{ $t("modal.common.required") }}</small>
              <small v-else>*</small>
          </label>
        </div>
      </div>

      <!-- Days of week -->
      <div class="component-modal__row">
        <label style="color: #ffffff99">
          {{ $t("modal.spot_programming.spot.simpleSchedule.daysToSchedule") }} 
          <small v-if="submitted && (!model.monday && !model.tuesday && !model.wednesday && !model.thursday && !model.friday && !model.saturday && !model.sunday)" class="pill-required">* {{ $t("modal.common.required") }}</small>
          <small v-else style="color: tomato">*</small>
        </label>

        <div style="display: flex; gap: 12px; margin: 8px 0px">
          <button class="outline small" @click="selectOptionDaysToSchedule('ALL')">{{ $t('modal.spot_programming.spot.simpleSchedule.allDates') }}</button>
          <button class="outline small" @click="selectOptionDaysToSchedule('MONDAY_FRIDAY')">{{ $t('modal.spot_programming.spot.simpleSchedule.mondayToFriday') }}</button>
          <button class="outline small" @click="selectOptionDaysToSchedule('NONE')">{{ $t('modal.spot_programming.spot.simpleSchedule.customizable') }}</button>
        </div>

        <div style="display:flex; justify-content: space-between">
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="model.monday">
              {{ $t("days_of_week.monday") }}
            </label>
          </div>
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="model.tuesday">
              {{ $t("days_of_week.tuesday") }}
            </label>
          </div>
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="model.wednesday">
              {{ $t("days_of_week.wednesday") }}
            </label>
          </div>
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="model.thursday">
              {{ $t("days_of_week.thursday") }}
            </label>
          </div>
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="model.friday">
              {{ $t("days_of_week.friday") }}
            </label>
          </div>
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="model.saturday">
              {{ $t("days_of_week.saturday") }}
            </label>
          </div>
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="model.sunday">
              {{ $t("days_of_week.sunday") }}  
            </label>
          </div>
        </div>
      </div>

      <div class="component-modal-section">
        <div class="component-modal__row component-modal__row__multiselect">
          <label for="name">{{$t('modal.spot_programming.spot.simpleSchedule.type')}}</label>
          <Multiselect
            v-model="model.timeMode"
            :searchable="false"
            :canDeselect="false"
            :canClear="false"
            :options="[
              { value: 0, label: `${$t('modal.spot_programming.spot.simpleSchedule.type_timeInterval')}` },
              { value: 1, label: `${$t('modal.spot_programming.spot.simpleSchedule.type_show')}` },
              { value: 2, label: `${$t('modal.spot_programming.spot.simpleSchedule.type_commercialBreak')}` },
            ]"
            @select="model.timeMode = model.timeMode == null ? 0 : model.timeMode"
            :disabled="model.spotType == 2" />

          <!-- <select name="" id="" v-model="model.timeMode">
            <option :value="0">{{$t('modal.spot_programming.spot.simpleSchedule.type_timeInterval')}}</option>
            <option :value="1">{{$t('modal.spot_programming.spot.simpleSchedule.type_show')}}</option>
            <option :value="2">{{$t('modal.spot_programming.spot.simpleSchedule.type_commercialBreak')}}</option>
          </select> -->
        </div>
    
        <!-- By time interval -->
        <div class="component-modal__row--third" v-if="model.timeMode == 0">
          <div class="component-modal__column--third">
            <div class="component-modal-input component-modal-input--rename">
              <input type="time"  v-model="model.startTime" @change="validateTimes" @focus="$event.target.select()" :class="{'invalid': submitted && model.timeMode == 0 && model.startTime == '' || invalidDates}">
              <label>{{$t('modal.spot_programming.spot.simpleSchedule.startTime')}}
                <small v-if="submitted && model.timeMode == 0 && model.startTime == '' || invalidDates" class="pill-required">* {{ $t("modal.common.required") }}</small>
                <small v-else>*</small>
              </label>
            </div>
          </div>
          <div class="component-modal__column--third">
            <div class="component-modal-input component-modal-input--rename">
              <input type="time"  v-model="model.endTime" @change="validateTimes" @focus="$event.target.select()" :class="{'invalid': submitted && model.timeMode == 0 && model.endTime == '' || invalidDates}">
              <label>{{$t('modal.spot_programming.spot.simpleSchedule.endTime')}}
                <small v-if="submitted && model.timeMode == 0 && model.endTime == '' || invalidDates" class="pill-required">* {{ $t("modal.common.required") }}</small>
                <small v-else>*</small>
              </label>
            </div>
          </div>
          <div class="component-modal__column--third">
            <div class="component-modal-input component-modal-input--rename">
              <input type="number" name="occurrences" id="occurrences" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.spot.simpleSchedule.occurrences')" v-model="model.occurrences" :class="{'invalid': submitted && model.timeMode == 0 && model.occurrences == 0}">
              <label for="occurrences">{{$t('modal.spot_programming.spot.simpleSchedule.occurrences')}}
                <small v-if="submitted && model.timeMode == 0 && model.occurrences == 0" class="pill-required">* {{ $t("modal.common.required") }}</small>
                <small v-else>*</small>
              </label>
            </div>
          </div>
        </div>
        <template v-if="model.timeMode == 0 && model.startTime != '' && model.endTime != ''">
          <!-- Alert validation -->
          <div class="alert warning" v-if="invalidDates">
            <i class="material-icons">info_outline</i>
            {{$t("modal.station_config.schedules.errorTime")}}
          </div>
        </template>

        <!-- By show -->
        <div v-if="model.timeMode == 1">
          <div class="component-modal__row--half">
            <div class="component-modal__column--half component-modal__row__multiselect">
              <!-- <div class="component-modal-input component-modal-input--rename"> -->
                <label for="show">{{$t("modal.spot_programming.spot.detailedSchedule.show")}}
                  <small v-if="submitted && model.timeMode == 1 && model.showId == null" class="pill-required">* {{ $t("modal.common.required") }}</small>
                  <small v-else>*</small>
                </label>
                <Multiselect
                  v-model="model.showId"
                  :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.detailedSchedule.show')"
                  track-by="customLabel"
                  valueProp="id"
                  label="customLabel"
                  :searchable="false"
                  :canDeselect="false"
                  :canClear="false"
                  :options="listPrograms"
                  :class="{'invalid': submitted && model.timeMode == 1 && model.showId == null}" />

                <!-- <select name="show" id="show" v-model="model.showId" :class="{'invalid': submitted && model.timeMode == 1 && model.showId == null}">
                  <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.detailedSchedule.show")}}</option>
                  <option v-for="show in listPrograms" :key="show.id" :value="show.id">{{show.code}} - {{show.name}}</option>
                </select> -->
              <!-- </div> -->
            </div>
            <div class="component-modal__column--half">
              <div class="component-modal-input component-modal-input--rename">
                <input type="number" name="occurrences" id="occurrences" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.spot.simpleSchedule.occurrences')" v-model="model.occurrences" :class="{'invalid': submitted && model.timeMode == 1 && model.occurrences == 0}">
                <label for="occurrences">{{$t('modal.spot_programming.spot.simpleSchedule.occurrences')}}
                  <small v-if="submitted && model.timeMode == 1 && model.occurrences == 0" class="pill-required">* {{ $t("modal.common.required") }}</small>
                  <small v-else>*</small>
                </label>
              </div>
            </div>
          </div>
        </div>
        
        <!-- By specific batch -->
        <div v-if="model.timeMode == 2"> 
          <div class="component-modal__row input-time">
            <div class="component-modal-input">
              <input type="time"  v-model="valueExactTimes" @keyup.enter="$event.target.blur(); $event.target.focus()" @focus="$event.target.select()" :class="{'invalid': submitted && model.timeMode == 2 && arrExactTimes.length == 0}">
              <label for="name">{{$t('modal.spot_programming.spot.simpleSchedule.time')}}
                <small v-if="submitted && model.timeMode == 2 && arrExactTimes.length == 0" class="pill-required">* {{ $t("modal.common.required") }}</small>
                <small v-else>*</small>
              </label>
              <button @click="addHour(valueExactTimes)">{{$t('modal.spot_programming.spot.simpleSchedule.add')}}</button>
            </div>
          </div>

          <ul class="list-tabs">
            <li v-for="(times, idxTimes) in arrExactTimes" :key="times">{{times}} <i class="material-icons" @click="removeTime(idxTimes)">close</i> </li>
          </ul>
        </div>
      </div>

      <!-- Business -->
      <div class="component-modal-section">
        <strong>{{$t("modal.spot_programming.spot.simpleSchedule.business")}}</strong>
        <div class="component-modal__row--third">
          <div class="component-modal__column--third component-modal__row__multiselect">
            <!-- <div class="component-modal-input component-modal-input--rename"> -->
              <label for="name">{{$t("modal.spot_programming.spot.simpleSchedule.show")}}</label>
              <Multiselect
                  v-model="model.idBusinessShow"
                  :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.simpleSchedule.show')"
                  track-by="customLabel"
                  valueProp="id"
                  label="customLabel"
                  :searchable="false"
                  :options="listPrograms" />
              <!-- <select name="" id="" v-model="model.idBusinessShow">
                <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.simpleSchedule.show")}}</option>
                <option v-for="show in listPrograms" :key="show.id" :value="show.id">{{show.code}} - {{show.name}}</option>
              </select> -->
            <!-- </div> -->
          </div>
          <div class="component-modal__column--third component-modal__row__multiselect">
            <!-- <div class="component-modal-input component-modal-input--rename"> -->
              <label for="businessUnit">{{$t("modal.spot_programming.spot.simpleSchedule.unit")}}</label>
              <Multiselect
                  v-model="model.businessUnitId"
                  :placeholder="$t('modal.placeholder_select') + $t('modal.spot_programming.spot.simpleSchedule.unit')"
                  track-by="customLabel"
                  valueProp="id"
                  label="customLabel"
                  :searchable="false"
                  :options="listBusinessUnit" />
              <!-- <select name="businessUnit" id="businessUnit" v-model="model.businessUnitId">
                <option :value="null">{{$t("modal.placeholder_select")}}{{$t("modal.spot_programming.spot.simpleSchedule.unit")}}</option>
                <option v-for="business in listBusinessUnit" :key="business.id" :value="business.id">{{business.code}} - {{business.description}}</option>
              </select> -->
            <!-- </div> -->
          </div>

          <div class="component-modal__column--third">
            <div class="component-modal-input component-modal-input--rename">
              <input type="number" name="businessMonthlyFee" id="businessMonthlyFee" autocomplete="off" :placeholder="$t('modal.placeholder_insert') + $t('modal.spot_programming.spot.simpleSchedule.monthlyFee')" v-model="model.businessMonthlyFee">
              <label for="businessMonthlyFee">{{$t("modal.spot_programming.spot.simpleSchedule.monthlyFee")}}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ props ? $t("modal.save") : $t('modal.create') }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && getErrors().length > 0">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', { inputs : getErrors().join(', ') })">
          </span>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { minValue, required } from '@vuelidate/validators';
import eventBus from '@/plugins/eventBus';
import moment from 'moment';
import useVuelidate from '@vuelidate/core';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
    const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const listProducts = computed(() => store.getters.product_productList);
    const listBusinessUnit = computed(() => store.getters.businessUnit_businessUnitList);
    const listPrograms = computed(() => store.getters.show_programsList);
    const listspeakers = computed(() => store.getters.speaker_speakerList);
    const calculateTime = computed(() => time => moment().startOf('day').seconds(time).format('mm:ss'))
    const submitted = ref(false);
    const invalidDates = ref(false);
    
    const model = ref({
      id: 0,
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: null,
      startTime: "00:00",
      endTime: "00:00",
      occurrences: 0,
      timeMode: 0,
      showId: null,
      exactTimes: "",
      timeFee: 0,
      commercialBreakSpotPosition: 2,
      speakerId: null,
      spotType: 0,
      filename: "",
      length: 0,
      ntcText: "",
      businessUnitId: null,
      idBusinessShow: null,
      businessMonthlyFee: 0,
      productId: null,
      price: 0
    });
    const valueExactTimes = ref('');
    const arrExactTimes = ref([]);

    onMounted(async () => {
      store.dispatch('loading_setActive', true);

      model.value['internalReferenceSpot'] = props.value.internalReferenceSpot;
      if (props.value.edit) {
        props.value.monday = (props.value.monday == 1);
        props.value.tuesday = (props.value.tuesday == 1);
        props.value.wednesday = (props.value.wednesday == 1);
        props.value.thursday = (props.value.thursday == 1);
        props.value.friday = (props.value.friday == 1);
        props.value.saturday = (props.value.saturday == 1);
        props.value.sunday = (props.value.sunday == 1);
        props.value.startDate = moment(props.value.startDate).format("YYYY-MM-DD");
        props.value.endDate = moment(props.value.endDate).isValid() ? moment(props.value.endDate).format("YYYY-MM-DD") : null;
        if (props.value.exactTimes && props.value.exactTimes != '') arrExactTimes.value = props.value.exactTimes.split(",");
        props.value.editReady = true;
        model.value = Object.assign({}, props.value);
      }
      
      await store.dispatch('businessUnit_getAll');
      await store.dispatch('show_getAll');
      await store.dispatch('speaker_getAll');
      await store.dispatch('product_getAll', props.value.stationId);

      if (listProducts.value.length == 1) model.value.productId = listProducts.value[0].id

      // Detect paste in fileName
      document.getElementById("spotFileName").addEventListener("paste", event => {
        event.preventDefault();
        let paste = event.clipboardData.getData("text/data") || event.clipboardData.getData('text');
        changeSpotFileName(paste);
      })
      store.dispatch('loading_setActive', false);
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    async function saveAndClose() {
      submitted.value = true;
      // Validate custom
      const validateText = () => {
        if (model.value.spotType == 1) {
          return model.value.ntcText != '';
        }
        return true;
      }
      validateTimes();
      const validateDays = (model.value.monday || model.value.tuesday || model.value.wednesday || model.value.thursday || model.value.friday || model.value.saturday || model.value.sunday)
      const validateType = () => {
        if (model.value.timeMode == 0) {
          return model.value.startTime != '' && model.value.endTime != '' && model.value.occurrences > 0 && !invalidDates.value;
        }
        if (model.value.timeMode == 1) {
          return (model.value.showId != null && model.value.occurrences > 0);
        }
        if (model.value.timeMode == 2) {
          return (arrExactTimes.value.length > 0)
        }
      };
      if (!v$.value.model.$invalid && validateText() && validateDays && validateType()) {
        // Convert value dates
        model.value.monday = model.value.monday ? 1 : 0;
        model.value.tuesday = model.value.tuesday ? 1 : 0;
        model.value.wednesday = model.value.wednesday ? 1 : 0;
        model.value.thursday = model.value.thursday ? 1 : 0;
        model.value.friday = model.value.friday ? 1 : 0;
        model.value.saturday = model.value.saturday ? 1 : 0;
        model.value.sunday = model.value.sunday ? 1 : 0;
        // Exact times es el valor de los horarios concatenados por ',';
        model.value.exactTimes = arrExactTimes.value.sort().join(",");
  
        eventBus.$emit(props.value.edit ? 'editSimpleSchedule' : 'addSimpleSchedule', model.value);  
        this.closeModal();
      }
    }

    function changeSpotType(type) {
      if (type != 1) model.value.ntcText = '';
      if (type != 2) {
        model.value.commercialBreakSpotPosition = 2;
      } else {
        model.value.commercialBreakSpotPosition = 6;
      }
      // 
      if (type == 2) model.value.timeMode = 2;
    }

    function validateTimes() {
      function _getMoment(time) {
        const [start, end] = time.split(":");
        return moment().hour(start).minutes(end);
      }

      if (model.value.startTime != '' && model.value.endTime != '') {
        // Validar que start sea distinto a end
        if (model.value.startTime == model.value.endTime) {
          invalidDates.value = true;
          return;
        }
        // Validar que start sea previo a end
        const startTimeValidate = _getMoment(model.value.startTime);
        const endTimeValidate = _getMoment(model.value.endTime);
        invalidDates.value = moment(startTimeValidate).isAfter(endTimeValidate);
      } else { 
        invalidDates.value = false;
      }
    }

    function addHour(hour) {
      if (hour != '') {
        if (!arrExactTimes.value.includes(hour)) {
          arrExactTimes.value.push(hour);
          arrExactTimes.value = arrExactTimes.value.sort();
        } else {
          store.dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.timeExist')}`, title: window.vueApp.$t('workspace.spot_detail.simple_programming'), error: true});
        }
        valueExactTimes.value = '';
      }
    }

    function removeTime(idx) {
      arrExactTimes.value.splice(idx, 1);
    }

    function getErrors() {
      let errors = [];
      const that = this;

      if (that.v$.model.$silentErrors.length > 0) {
        errors.push(that.v$.model.$silentErrors.map(error => window.vueApp.$t(`modal.spot_programming.spot.simpleSchedule.${error.$property == 'filename' ? 'spotFileName' : error.$property}`)));
      }
      
      const validateDays = (model.value.monday || model.value.tuesday || model.value.wednesday || model.value.thursday || model.value.friday || model.value.saturday || model.value.sunday)
      if (!validateDays) errors.push(window.vueApp.$t('modal.spot_programming.spot.simpleSchedule.daysToSchedule')); 
      
      // Interval time
      if (model.value.timeMode == 0) {
        if (invalidDates.value) {
          errors.push(window.vueApp.$t('modal.spot_programming.spot.simpleSchedule.startTime'))
          errors.push(window.vueApp.$t('modal.spot_programming.spot.simpleSchedule.endTime'))
        }
        if (model.value.occurrences == 0) errors.push(window.vueApp.$t('modal.spot_programming.spot.simpleSchedule.occurrences'))
      } else if (model.value.timeMode == 1) {
        if (model.value.showId == null) errors.push(window.vueApp.$t('modal.spot_programming.spot.simpleSchedule.show'))
        if (model.value.occurrences == 0) errors.push(window.vueApp.$t('modal.spot_programming.spot.simpleSchedule.occurrences'))
      } else if (model.value.timeMode == 2) {
        if (arrExactTimes.value.length == 0) errors.push(window.vueApp.$t('modal.spot_programming.spot.simpleSchedule.time'))
        
      }
      
      return errors;
    }

    function changeSpotFileName(fileName) {
      const lastIndex = fileName.lastIndexOf(' *');
      if (lastIndex > -1) {
        model.value.length = Number(fileName.substring(lastIndex + 2));
        model.value.filename = fileName.substring(0, lastIndex);
      } else {
        model.value.filename = fileName
      }
    }

    function updateProduct() {
      const product = listProducts.value.find(product => product.id == model.value.productId);
      if (product) model.value.price = product.price;
    }

    function comparePriceProduct(productId, price) {
      const product = listProducts.value.find(product => product.id == productId);
      return product ? product.price != price : false;
    }

    function calculateTimeMention() {
      if (model.value.spotType == 1) {
        const qty = model.value.ntcText.split(' ');
        model.value.length = Math.round((qty.length + 1) * 0.4);
      }
    }

    function selectOptionDaysToSchedule (option) {
      switch (option) {
        case 'ALL':
          model.value.monday = true;
          model.value.tuesday = true;
          model.value.wednesday = true;
          model.value.thursday = true;
          model.value.friday = true;
          model.value.saturday = true;
          model.value.sunday = true;
          break;
        case 'MONDAY_FRIDAY':
          model.value.monday = true;
          model.value.tuesday = true;
          model.value.wednesday = true;
          model.value.thursday = true;
          model.value.friday = true;
          model.value.saturday = false;
          model.value.sunday = false;
          break;
        case 'NONE':
          model.value.monday = false;
          model.value.tuesday = false;
          model.value.wednesday = false;
          model.value.thursday = false;
          model.value.friday = false;
          model.value.saturday = false;
          model.value.sunday = false;
          break;
      }
    }

    return {
      v$,
      props,
      model,
      listBusinessUnit,
      listPrograms,
      listspeakers,
      arrExactTimes,
      valueExactTimes,
      calculateTime,
      submitted,
      invalidDates,
      listProducts,
      saveAndClose,
      updateProduct,
      closeModal,
      changeSpotType,
      validateTimes,
      addHour,
      removeTime,
      getErrors,
      comparePriceProduct,
      calculateTimeMention,
      selectOptionDaysToSchedule
    }
  },
  validations () {
    return {
      model: {
        startDate:{required},
        timeMode:{required},
        filename:{required},
        length:{required, minValueValue: minValue(1)},
        productId: {required}
			}
    }
  }
};
</script>
<style lang="scss" scoped>
  .input-time {
    .component-modal-input {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    input {
      max-width: 100px;
    }
  }
  
  label {
    overflow: hidden;
  }
  .time {
    position: absolute;
    top: 0px;
    color: black;
    background: gray;
    padding: 2px 8px;
    border-radius: 12px;
    margin-left: 4px;
    font-size: 12px;
  }
</style>